var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.727 9.364h14.545v8H4.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90929C",
    d: "M17.95 5.12c1.23 0 1.93.769 1.93 2.062v8.727c0 1.293-.7 2.062-1.93 2.062H6.05c-1.23 0-1.93-.77-1.93-2.062V7.182c0-1.293.7-2.062 1.93-2.062h11.9zm.715 4.85H5.334v5.94c0 .646.183.846.716.846h11.9c.533 0 .715-.2.715-.847V9.971zM6.909 14.576h2.182a.607.607 0 0 1 .076 1.21l-.076.004H6.909a.607.607 0 0 1-.076-1.21l.076-.004h2.182-2.182zm8.727 0a.607.607 0 1 1 0 1.214h-4.363a.607.607 0 0 1 0-1.214h4.363zm2.314-8.24H6.05c-.533 0-.715.2-.715.847l-.001 1.574h13.33l.001-1.574c0-.647-.182-.847-.715-.847z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.8fb44cab9f95f767c58bd44b6e7dd537.svg";
export { ForwardRef as ReactComponent };